import React from "react";
import Link from "helpers/link";
import Image from "components/image";
import { SocialMedia } from "components/link-types";
import TotalReviews from "components/total-reviews";
import PaymentIcons from "components/payment-icons";

export const GroupLinks = ({ data }) =>
	data?.map((group) => (
		<div key={group._key} className="flex flex-col">
			<Link to={group?.url}>
				<span className="text-sm tracking-widest font-medium">{group.title}</span>
			</Link>
			{group.groupLinkData.map((data) => (
				<Link key={data._key} to={data.url} className="footer-group-link">
					{data.title}
				</Link>
			))}
		</div>
	));

export const PrivacyLinks = ({ data }) =>
	data?.length && (
		<div className="opacity-30 flex items-center justify-evenly lg:justify-start flex-wrap gap-1 text-small text-left mx-auto md:m-0 w-full lg:w-[70%]">
			{data?.map((link, index) => (
				<React.Fragment key={link._key}>
					<Link key={link._key} to={link.url}>
						{link.title}
					</Link>
					<span className={`text-small ${index === 1 ? "lg:hidden" : ""}`}>{index + 1 !== data.length ? " | " : " "} </span>
				</React.Fragment>
			))}
		</div>
	);

export const FooterSocial = ({ data, privacyLinks }) => (
	<div className="flex flex-col gap-5 w-1/6">
		<Link to={data?.logo?.url}>
			<div>
				<Image width={78} image={data?.logo} />
			</div>
		</Link>
		<span>{data?.tagline}</span>
		{data?.showSocialIcons && (
			<div className="flex flex-row justify-between max-w-[75%]">
				<SocialMedia list={["instagram", "facebook", "youtube", "linkedin", "tiktok"]} />
			</div>
		)}
		<PrivacyLinks data={privacyLinks} />
	</div>
);

export const FooterIcons = ({ icons }) => (
	<div className="flex flex-col gap-7 items-center w-1/6">
		<Link to={icons?.reviews?.url}>
			<div className="w-40">
				<TotalReviews direction="vertical" />
			</div>
		</Link>
		<Link to={icons?.carbonNeutral?.url}>
			<div className="w-40">
				<Image image={icons?.carbonNeutral} alt={icons?.carbonNeutral?.alt} />
			</div>
		</Link>
		{icons?.paymentIcons?.length && <PaymentIcons data={icons?.paymentIcons} />}
	</div>
);
